export default function BentonvilleTestimonialsSection() {
  return (
    <section id="testimonials" className="bg-[#1A365D] py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Traveler Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-4">What Bentonville &amp; NWA Residents Say</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { name: "Christine L.", location: "Walmart Home Office, Bentonville", text: "I lead a global team and travel to China 6 times a year. When my passport was expiring mid-trip, Fast Passport Center had a new one expedited in 3 days. They understand corporate travel needs perfectly." },
            { name: "James & Karen W.", location: "Bella Vista, AR", text: "We planned a European river cruise for our 30th anniversary. Our passports had expired. Fast Passport Center renewed both in one week. The Rhine was absolutely stunning." },
            { name: "Alex T.", location: "Walmart Global Tech, Bentonville", text: "Got an emergency assignment to Bangalore with 5 days notice. New passport in hand in 48 hours. If you work at Walmart or any NWA tech company, keep this service in your contacts." },
          ].map((t, i) => (
            <div key={i} className="bg-white/10 backdrop-blur rounded-lg p-6 border border-white/10">
              <div className="flex items-center gap-1 mb-4">{[1,2,3,4,5].map((s) => <i key={s} className="ri-star-fill text-[#F6C344] text-sm"></i>)}</div>
              <p className="text-white/90 text-sm leading-relaxed mb-4">"{t.text}"</p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[#F6C344] flex items-center justify-center text-[#1A365D] font-bold text-sm">{t.name[0]}</div>
                <div><p className="text-white font-semibold text-sm">{t.name}</p><p className="text-white/60 text-xs">{t.location}</p></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}